<template>
  <div style="background:#fff">
    <header class="aui-navBar aui-navBar-fixed b-line">
      <a @click="returnPage" class="aui-navBar-item">
        <i class="icon icon-return"></i>
      </a>
      <div class="aui-center">
        <span class="aui-center-title">消费记录</span>
      </div>
      <a @click="returnHome" class="aui-navBar-item">
        <i class="icon icon-sys"></i>
      </a>
    </header>
    <section class="aui-scrollView no-foot">
      <van-list
        v-model="loading"
        :finished="finished"
        :finished-text="finishedText"
        @load="getList"
      >
       <ul class="pay-list">
        <li v-for="item in list" :id="item.bookId +''+ item.chapterNumber" :key="item.bookId +''+ item.chapterNumber">
          <div class="l">
            <strong>{{item.bookTitle}}</strong>
            <span>第{{item.chapterNumber}}章 {{item.chapterTitle}}</span>
          </div>
          <div class="r">
            <strong class="c-red">-{{item.chapterPrice}}书币</strong>
            <span>{{item.gmtBuy}}</span>
          </div>
        </li>
      </ul>
       <van-empty v-if="list.length === 0 && finished" description="暂无消费记录" />
      </van-list>
    </section>
  </div>
</template>

<script>
import userService from '../../../services/userService'
export default {
  name: 'purchase-history',
  data () {
    return {
      loading: false,
      finished: false,
      list: [],
      currentPage: 1,
      finishedText: ''
    }
  },
  methods: {
    returnPage () {
      this.$router.isBack = true
      this.$router.go(-1)
    },
    returnHome () {
      this.$router.isBack = false
      this.$router.push('/home')
    },
    getList () {
      const { finished, currentPage, list } = this
      if (finished) return
      userService.buyRecords(currentPage).then(res => {
        const resData = res.data
        const items = resData.items || []
        this.loading = false
        this.list = list.concat(items)
        if (currentPage >= resData.totalPage || items.length === 0) {
          this.finished = true
          if (this.list.length > 6) {
            this.finishedText = '没有更多了'
          } else {
            this.finishedText = ''
          }
        } else {
          this.currentPage++
        }
      })
    },
    getList1 () {
      userService.buyRecords().then(res => {
        const resData = res.data
        if (res.result) {
          this.list = resData.items || []
        }
      })
    }
  },
  created () {
    this.$router.isBack = true
  }
}
</script>

<style scoped>
</style>
